import { render, staticRenderFns } from "./CreateParamGroup.vue?vue&type=template&id=5b88d75b&scoped=true"
import script from "./CreateParamGroup.vue?vue&type=script&lang=js"
export * from "./CreateParamGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b88d75b",
  null
  
)

export default component.exports